import { render, staticRenderFns } from "./FormElementTable.vue?vue&type=template&id=6b653345&"
import script from "./FormElementTable.vue?vue&type=script&lang=js&"
export * from "./FormElementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports